import quarkusApi from '../../../api/quarkusApi';

export function useDeleteUser() {
  const remove = (userId) =>
    quarkusApi.delete(`/configuration/clinic-users/${userId}`, {
      headers: { Authorization: sessionStorage.getItem('token') },
    });

  return { remove };
}
